import { getSymbolsFetcher } from './fetcher';
import { SymbolsResponse } from './types';

export type GetSymbolsParams = {
  ticker: string;
};

export const getSymbols = async ({
  ticker,
}: GetSymbolsParams): Promise<SymbolsResponse | null> => {
  try {
    const response = await getSymbolsFetcher({
      symbol: ticker,
    });

    return response;
  } catch (error) {
    console.error('Error fetching symbols:', error);

    return null;
  }
};
